/**
 * created by xcc on 2022/5/23
 * 网站投递关系接口
 */

import request from "../../base/request";

let host = "/cm-sites-pms/website/";

const Apis = {
    getListData: host + "pageListColumnSync", //网站投递关系列表
    getCurrentDeptColumnTree: host + 'getColumnTrees', //获取当前部门的所有网站栏目树
    saveColumnSyn: host + 'saveColumnSyn', //保存
    deleteColumnSynById: host + 'deleteColumnSynById', //删除
}

export const getListData = (body, callBack) => {
    request({url: Apis.getListData, body, callBack});
};
export const getCurrentDeptColumnTree = (body, callBack) => {
    request({url: Apis.getCurrentDeptColumnTree, body, callBack});
};
export const saveColumnSyn = (body, callBack) => {
    request({url: Apis.saveColumnSyn, contentType: "json", method: "post", body, callBack});
};
export const deleteColumnSynById = (body, callBack) => {
    request({url: Apis.deleteColumnSynById, method: "post", body, callBack});
};